import { createResourceSlice } from '@shared/utils/createResourceSlice';
import { StopHeader } from '@shared/models/stopHeader';
import { Journey } from '@modules/vehicle/models/real-time/journey';

export const stopHeaderSlice = createResourceSlice<StopHeader>('stopHeader');
export const journeySlice = createResourceSlice<Journey>('journey');
